import React from "react";
import { Navigate } from "react-router-dom";
import { isUserDriver, isUserTech } from "src/constants/user_constants";

// First route-guard in this app - reads the raw "user" blob from localStorage the same
// way LoginForm.jsx/Nav.jsx already do, rather than introducing a new context/store.
function RequireRole({ allow, redirectTo, children }) {
  const user = JSON.parse(localStorage.getItem("user")) ?? null;
  const isDriver = isUserDriver(user);

  if (allow === "tech" && !isUserTech(user))
    return <Navigate to={redirectTo ?? "/dashboard/products"} replace />;
  if (allow === "driver" && !isDriver)
    return <Navigate to={redirectTo ?? "/dashboard/products"} replace />;
  if (allow === "non-driver" && isDriver)
    return <Navigate to={redirectTo ?? "/dashboard/driver"} replace />;

  return children;
}

export default RequireRole;
